export default __webpack_public_path__ + "static/media/svg-4.4904d780.svg";